<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <HeaderPadrao class="mb-2" icon="fa fa-address-book-o" titulo="CADASTRO DE FUNCIONÁRIO">
        <template #subtitulo>
          <div class="d-flex align-items-center flex-wrap">
            <span class="mr-2">
              <i class="fa fa-id-card-o mr-1 text-info"></i>
              CÓDIGO: <strong class="text-white">{{registro.CODIGO || 'Novo'}}</strong>
            </span>
            <span v-if="registro.NOME" class="mx-2">•</span>
            <span v-if="registro.NOME" class="mr-2">
              <i class="fa fa-user mr-1 text-info"></i>
              {{registro.NOME.substring(0,30)}}
            </span>
            
            <div class="ml-3 d-flex align-items-center">
              <b-badge :variant="registro.OP_SITUACAO === '1' ? 'success' : 'danger'" pill class="px-3 py-1 shadow-sm mr-2">
                {{registro.OP_SITUACAO === '1' ? 'ATIVO' : 'INATIVO'}}
              </b-badge>
              
              <b-badge v-if="registro.CARGO" variant="info" pill class="px-3 py-1 shadow-sm mr-2">
                {{registro.CARGO}}
              </b-badge>

              <b-badge variant="light" pill class="px-3 py-1 shadow-sm text-dark">
                FUNCIONÁRIO
              </b-badge>
            </div>
          </div>
        </template>

        <template #acoes>
          <b-button variant="link" class="btn-glass btn-glass-success px-4 font-weight-bold" @click.stop.prevent="postOrEdit()">
            <i class="fa fa-save mr-1"></i> GRAVAR
          </b-button>

          <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop.prevent="voltar()">
            <i class="fa fa-arrow-left mr-1"></i> Voltar
          </b-button>
        </template>
      </HeaderPadrao>


      <b-row class="px-2">
        <b-col sm="12">
          <!-- Identificação -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-id-card"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Identificação e Dados Básicos</h6>
                  <small class="text-muted">Nome, cargo e situação do colaborador</small>
                </div>
              </div>
            </template>

            <b-row class="mb-4 align-items-center">
              <b-col sm="2">
                <label class="modal-label-premium d-block mb-2">Status</label>
                <b-form-checkbox id="checkbox-status" v-model="registro.OP_SITUACAO" value="1" switch unchecked-value="0">
                  {{ registro.OP_SITUACAO === '1' ? 'Ativo' : 'Inativo' }}
                </b-form-checkbox>
              </b-col>
              <b-col sm="2">
                <label class="modal-label-premium">Código</label>
                <b-form-input type="text" id="ID" :disabled="true" placeholder="Automático" v-model="registro.CODIGO" class="rounded-pill shadow-xs bg-light"></b-form-input>
              </b-col>
              <b-col sm="8">
                <label class="modal-label-premium">Nome Completo *</label>
                <b-form-input type="text" id="edNOME" ref="edNOME" placeholder="Informe o Nome Completo" v-model="registro.NOME" :state="!!registro.NOME" class="rounded-pill shadow-xs"></b-form-input>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="4">
                <label class="modal-label-premium">Nome Resumido</label>
                <b-form-input type="text" id="edREZUMIDO" placeholder="Informe o Nome Resumido" v-model="registro.REZUMIDO" class="rounded-pill shadow-xs"></b-form-input>
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">Cargo *</label>
                <b-form-select :plain="true" v-model="registro.CARGO" :state="!!registro.CARGO" :options="optionsCARGO" class="rounded-pill shadow-xs"></b-form-select>
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">Telefone *</label>
                <the-mask class="form-control rounded-pill shadow-xs" id="telefone" mask="(##) #####-####" placeholder="(00) 00000-0000" v-model="registro.TELEFONE" :class="{ 'is-invalid': !registro.TELEFONE, 'is-valid': !!registro.TELEFONE }"></the-mask>
              </b-col>
            </b-row>
          </b-card>

          <!-- Endereço -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-success text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-map-marker"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Endereço e Localização</h6>
                  <small class="text-muted">Dados de residência do funcionário</small>
                </div>
              </div>
            </template>

            <b-row class="mb-3">
              <b-col sm="8">
                <label class="modal-label-premium">Endereço *</label>
                <b-form-input type="text" id="edENDERECO" placeholder="Rua, Avenida, etc." v-model="registro.ENDERECO" :state="!!registro.ENDERECO" class="rounded-pill shadow-xs"></b-form-input>
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">Bairro *</label>
                <b-form-input type="text" id="edBAIRRO" placeholder="Bairro" v-model="registro.BAIRRO" :state="!!registro.BAIRRO" class="rounded-pill shadow-xs"></b-form-input>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="2">
                <label class="modal-label-premium">UF *</label>
                <b-form-select v-model="registro.ID_UF" :options="estados" value-field="ID" text-field="ID" :state="!!registro.ID_UF" class="rounded-pill shadow-xs"></b-form-select>
              </b-col>
              <b-col sm="10">
                <label class="modal-label-premium">Município *</label>
                <div class="d-flex align-items-center">
                  <b-form-select :plain="true" v-model="registro.ID_MUNICIPIO" :options="municipios.items" :disabled="municipios.busy || !registro.ID_UF" :state="!!registro.ID_MUNICIPIO" value-field="ID" text-field="NOME" class="rounded-pill shadow-xs flex-grow-1"></b-form-select>
                  <b-spinner v-if="municipios.busy" small class="ml-2 text-primary"></b-spinner>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import Tools from '@/tools/tools.js'
import moment from 'moment'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'

export default {
  components: {
    HeaderPadrao
  },
  data () {
    return {
      desabilitado: true,
      formatoQuantidade: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimal: ',',
        precision: 3
      },
      formatoPecas: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimalPlaces: '0',
        roundingMethod: 'U',
        minimumValue: '0'
      },
      formatoPercentual: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimalPlaces: '3',
        roundingMethod: 'U',
        minimumValue: 0,
        maximumValue: 100,
        suffixText: ' %',
        modifyValueOnWheel: false
        
      },
      formatoMoeda: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimalPlaces: '2',
        roundingMethod: 'U',
        minimumValue: 0,
        prefix: 'R$: ',
        modifyValueOnWheel: false
        
      },
      optionsCARGO: [
        { value: null, text: 'Selecione' },
        { value: 'CONFERENTE', text: 'CONFERENTE' },
        { value: 'MOTORISTA', text: 'MOTORISTA' },
        { value: 'BALANCEIRO', text: 'BALANCEIRO' },
        { value: 'ESCRITORIO', text: 'ESCRITORIO' },
        { value: 'OUTROS', text: 'OUTROS' },
      ],
      estados: [],
      municipios: {
        items: [],
        busy: false,
      },
      
      registro: {
        CODIGO             : null,
        NOME               : null,
        REZUMIDO           : null,
        CARGO              : null,
        TELEFONE           : null,
        ENDERECO           : null,
        CIDADE             : null,
        BAIRRO             : null,
        UF                 : null,
        SETOR              : null,
        STATUS             : null,
        OBS1               : null,
        OBS2               : null,
        AREA               : null,
        ID_MUNICIPIO       : null,
        ID_UF              : null,
        OP_SITUACAO        : null,
        USUARIO_CADASTRO   : null,
        USUARIO_ALTERACAO  : null,
        DT_CADASTRO        : null,
        DT_ALTERACAO       : null,
      },
    }
  },
  
  methods: {
    voltar() {
      this.$router.push('/cadastros/funcionario/index')
    },
    async postOrEdit () {
      if (this.avisos()) return
      
      try {
        this.$store.commit('controle/setAguardando', true)  
        if (!this.registro.CODIGO) {
          
          try {  
            const postPayload = {
              registro: this.registro,
              login: window.localStorage.getItem('login')
            }

            const { data } = await this.$http.post(`/api/protected/funcionario/post`, postPayload)
            
            if (!data || !data.registro) {
              Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! Não foi possível cadastrar!' )  
              return
            }
            
            this.registro = {...data.registro[0]}
            this.$store.commit("funcionario/SET_LIMPAR", null)
            this.$store.commit("funcionario/SET_REGISTRO_SELECIONADO_ID", this.registro.CODIGO)
            //this.$store.commit("funcionario/SET_ID", this.registro.CODIGO)
            this.$store.commit('funcionario/SET_PAGINA_ATUAL', 1)
            //await this.$store.dispatch('funcionario/GET_LISTA')
            this.$store.commit("funcionario/SET_LIMPAR_APENAS_FILTRO", null) // limpar o filtro pq ja localizou o registro novo 

            this.$store.commit('controle/setAguardando', false)  

            
            this.$router.push('/cadastros/funcionario/index')

          } catch(err) {
            console.log(err)
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! Não foi possível gravar as informações' )
            return
          }

        } else {
          try {        
            const editPayload = {
              registro: this.registro,
              login: window.localStorage.getItem('login'),
              operacao: this.emAlteracao == true ? 'alt' : 'inc' //necessario para o backend entender se o form inicio como novo ou iniciou como edicao
            }
            let { data } = await this.$http.post(`/api/protected/funcionario/edit`, editPayload)
            this.registro = (data?.registro) ?? null

            this.$store.commit('controle/setAguardando', false)  

            this.$router.push('/cadastros/funcionario/index')

          } catch(err) {
            console.log(err)
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! Não foi possível gravar os dados solicitados' )
            return
          }

          
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)  
      }
    },
    limparRegistro () {
      Tools.resetToNull(this.registro, true)  
      this.registro.STATUS = '1'
      this.registro.CARGO = 'CONFERENTE'

    },
    
    
    avisos() {
      if (!this.registro.NOME) {
        this.$refs.edNOME.$refs.input.focus()
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Nome')
        return true
      }
      return false
      
    },
    async carregarEstados () {
      try {
        const result = await this.$http.get('/api/protected/estados')
        this.estados = result.data
      } catch(err) {
        console.log(err)
        this.estados = []
      }
    },
    async carregarMunicipios () {
      this.municipios.busy = true
      
      this.municipios.items = []
      
      if (this.registro.ID_UF) {
        try {
          const {data} = await this.$http.get(`/api/protected/municipios/${this.registro.ID_UF}`)
          this.municipios.items = data
          
          this.municipios.busy = false
        } catch(err) {
          console.log(err)
          this.municipios.busy = false
        }
      }
    }
    
  },
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  }
    
  },
  async created () {
    const id = this.$route.params.id ? Number(this.$route.params.id) : null

    try {
      
      if ( id ) {
        this.emAlteracao = true
        await this.carregarEstados()
        const { data: result } = await this.$http.get(`/api/protected/funcionario/getById/${id}`)
        if (!Array.isArray(result) || result.length === 0) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Cadastro não localizado.')
          this.$router.replace('/cadastros/funcionario/index')
          return
        }
        
        this.registro = { ...result[0] }
      } else {
        
        this.emAlteracao = false
        await this.limparRegistro()
        await this.carregarEstados()
      }
    } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        this.$router.replace('/cadastros/funcionario/index') 
    } finally {
      this.$store.commit('controle/setAguardando', false)  
    }
  },
  mounted (){
    this.$nextTick(() => {
      if (!this.$route.params.CODIGO) {
        // tenta API do componente; se não, foca no input interno
        const c = this.$refs.edNOME
        if (c?.focus) c.focus()
        else c?.$el?.querySelector('input')?.focus()
      }
    })
  },
  watch: {
    'registro.ID_UF': async function () {
      await this.carregarMunicipios()
    },
    
  }
}
</script>
<style lang="css" scoped>
.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  color: #718096;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  margin-bottom: 0.5rem;
}

.shadow-xs {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.rounded-pill {
  border-radius: 50rem !important;
}

.transition-hover {
  transition: all 0.2s ease-in-out;
}

.transition-hover:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
}

/* Custom input styles */
.form-control:focus {
  border-color: #3182ce;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.15);
}

.card {
  border-radius: 1rem;
}

.card-header {
  background-color: transparent;
  border-bottom: 1px solid rgba(0,0,0,0.05);
  padding: 1.25rem 1.5rem;
}

.btn-glass {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  border-radius: 50px;
  transition: all 0.3s ease;
}

.btn-glass:hover {
  background: rgba(255, 255, 255, 0.25);
  color: white;
  transform: translateY(-1px);
}

.btn-glass-success:hover {
  background: rgba(40, 167, 69, 0.8);
  border-color: rgba(40, 167, 69, 0.9);
}
</style>




// WEBPACK FOOTER //
// src/views/cadastros/funcionario/FuncionarioCadastro.vue